<template>
	<div class="section">
    <div class="section__header">
      <h2>Нераспределенные ученики</h2>
      <back></back>

      <input 
        type="text" 
        class="uk-input search-input" 
        v-model="searchInput" 
        placeholder="Поиск по имени"
      >
    </div>

		<div class="section__body">     

      <Sort class="sort" :sortTypes="sortTypes" />

			<ul class="wh-block__items">
				<li 
          v-for="item in sortedItems" 
          :key="item.id" 
          class="wh-block__stud" 
          @click.prevent="getStudent(item)"
        >
          <span>
            {{ item.name }}
            <small>
              <span v-if="item.age > 0">{{ item.age }} лет </span>
              <span v-if="!item.is_activated && !item.activated_at">(НОВЫЙ)</span>
            </small>
          </span>
					
					<small>
						<span v-if="item.property && item.property.city">{{ item.property.city }} </span>
					</small>
					<div class="wh-block__hover">
						Забрать себе
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
  import swal from "sweetalert";
  import { sort_mix } from '../../mixins/sort_mix'
  import { mapMutations } from 'vuex'

  export default {
    mixins: [sort_mix],
    name: "unattached-students",
    inject: ['http'],
    data() {
      return {
        searchInput: '',
        students: [],
        sortTypes: {
          'is_activated': 'Новые',
          'name': 'По имени'
        }
      }
    },   
    computed: {
      items() {
        return this.students.filter(item => item.name.toLowerCase().includes(this.searchInput.toLowerCase()))
      }
    }, 
    methods: {
      ...mapMutations({
        updateStudent: 'teacher/updateStudent'
      }),
      getItems() {
        this.http.post('onGetStudentsWithoutTeacher')
          .then(res => {
            this.students = res.data
          })
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
      },
      getStudent(item) {
        swal({
          title: 'Внимание!',
          text: `Ученик ${item.name} будет привязан к Вам. Подтвердить?`,
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true,
        })
        .then((choise) => {
          if (choise) {
            let data = {
              student_id: item.id
            }
          this.http.post('onAttachOwnerlessStudent', data)
            .then(res => {
              swal('Успешно!', res.data.message, 'success');
              this.updateStudent(item)
            })
            .catch(e => swal('Что-то пошло не так', '' + e, 'error'))            
          }
        });
      }
    },
    created() {
      this.getItems();
    }
  }
</script>

<style lang="scss" scoped>
.search-input {
  max-width: 300px;
  margin-top: 20px;
}

.wh-block__stud {
  flex-direction: column;
}

.wh-block__items {
  width: 100%;
  margin-top: 20px;
}
</style>